<template>
  <div class="section section-testimonials-2 section-dark">
    <div class="container">
      <div class="md-layout">
        <div
          class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
        >
          <h2 class="title">Nuestros Clientes Opinan</h2>
        </div>
      </div>
      <el-carousel indicator-position="none" trigger="false" :interval="5000">
        <el-carousel-item>
          <testimonial-card card-plain>
            <template slot="cardContent">
              <h4 class="card-description">
                "Preciosa la vista al lago, muy buena atención del personal. No
                tiene restaurante, pero hay asadores".
              </h4>
              <h4 class="card-title">Alfredo Tellez</h4>
            </template>
            <template slot="cardAction">
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
            </template>
          </testimonial-card>
        </el-carousel-item>
           <el-carousel-item>
          <testimonial-card card-plain>
            <template slot="cardContent">
              <h4 class="card-description">
                
               "" Un buen lugar para descansar. A 10 minutos del centro de Valle
                de Bravo lo recomiendo totalmente."
              </h4>
              <h4 class="card-title">Gabriela Meneses</h4>
            </template>
            <template slot="cardAction">
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
            </template>
          </testimonial-card>
        </el-carousel-item>
        <el-carousel-item>
          <testimonial-card card-plain>
            <template slot="cardContent">
              <h5 class="card-description">
                "Excelente lugar a orilla del lago, muy tranquilo, excelentes
                vistas, atardecer precioso, muy recomendable, personal muy amable".
              </h5>
              <h4 class="card-title">Judith Méndez</h4>
            </template>
            <template slot="cardAction">
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
            </template>
          </testimonial-card>
        </el-carousel-item>
        <el-carousel-item>
          <testimonial-card card-plain>
            <template slot="cardContent">
              <h5 class="card-description">
                "Excelente experiencia y muy recomendable para despejarte de la
                ciudad. <br />
              
              </h5>
              <h4 class="card-title">Cesar Reyes</h4>
            </template>
            <template slot="cardAction">
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
            </template>
          </testimonial-card>
        </el-carousel-item>
        <el-carousel-item>
          <testimonial-card card-plain>
            <template slot="cardContent">
              <h5 class="card-description">
                Gran lugar, muy tranquilo para pasar el fin de semana, casi
                privado <br />
                son solo 10 habitaciones por lo que hay poca gente.
              </h5>
              <h4 class="card-title">Fernando Rosas</h4>
            </template>
            <template slot="cardAction">
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
            </template>
          </testimonial-card>
        </el-carousel-item>
        <el-carousel-item>
          <testimonial-card card-plain>
            <template slot="cardContent">
              <h5 class="card-description">
                El lugar muy tranquilo, excelente para descansar, tiene lo
                básico, buena atención del encargado.
              </h5>
              <h4 class="card-title">Carlos Campos</h4>
            </template>
            <template slot="cardAction">
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
              <md-icon class="text-warning"> star </md-icon>
            </template>
          </testimonial-card>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { TestimonialCard } from "@/components";

export default {
  name: "Testimonials",
  components: {
    TestimonialCard,
  },
  data() {
    return {};
  },
  methods: {
    sectionTestimonials(image) {
      return {
        backgroundImage: `url(${image})`,
      };
    },
  },
};
</script>


